module.exports = __webpack_public_path__ + "img/watch_image.a2193aae.jpg";